export default __webpack_public_path__ + "static/media/mau.5eb086a9.png";